import script from "./platGmPermissionApply.vue?vue&type=script&setup=true&lang=js"
export * from "./platGmPermissionApply.vue?vue&type=script&setup=true&lang=js"

import "./platGmPermissionApply.vue?vue&type=style&index=0&id=a5bc3de0&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5bc3de0"]])

export default __exports__